import { useMemo } from "react";
import type { BaseFormProps } from "../../types";

export const useFormControlProps = <T extends BaseFormProps & { id?: string }>(props: T) => {
	const {
		name,
		error,
		label,
		labelPosition,
		isRequired,
		formHelperText,
		containerClassName,
		description,
		hideError,
		...rest
	} = props;

	const controlId = props.id ?? name;
	const errorId = useMemo(() => `${controlId.replace(/\./g, "-")}-error`, [controlId]);

	return {
		formControlProps: {
			name,
			controlId,
			error,
			label,
			labelPosition,
			isRequired,
			formHelperText,
			containerClassName,
			description,
			hideError,
		},
		errorAria: error
			? {
					"aria-invalid": true,
					"aria-describedby": hideError ? undefined : errorId,
				}
			: {},
		baseProps: {
			name,
			...rest,
		},
	};
};
